import { render, staticRenderFns } from "./_page-betting-rules-squash.vue?vue&type=template&id=08c00358&lang=pug&"
import script from "./_page-betting-rules-squash.vue?vue&type=script&lang=js&"
export * from "./_page-betting-rules-squash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports